export default __webpack_public_path__ + "static/media/d84d87b4548a138b206be2bae58a0362.f6c74140.png";